import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ToolCard, tools } from '../pages/InteractiveTools';

const LatestTools = () => {
  const latestTools = tools.slice(0, 3);

  return (
    <section id="latest-tools" className="py-20 bg-emerald-950 text-emerald-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white">
            Latest Interactive Tools
          </h2>
          <p className="mt-3 text-lg text-emerald-100">
            Experiment with hydrogen blends, emissions and reliability using our
            newest calculators and demos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {latestTools.map((tool, index) => (
            <motion.div
              key={tool.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <ToolCard t={tool} />
            </motion.div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/interactive-tools"
            className="inline-flex items-center text-emerald-300 font-semibold hover:text-emerald-200 transition-colors"
          >
            Explore all tools
            <span aria-hidden="true" className="ml-1">
              
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LatestTools;
